import { useContext, useEffect, useRef } from "react";

// Utils
import { getCloudinaryRawUrl } from "@swiggy-private/js-utils";

// Constants
import {
    FESTIVE_END_DATE,
    FESTIVE_LOTTIE_ASSETS,
    FESTIVE_START_DATE,
    isDateWithinInterval,
    LOTTIE_ASSETS,
} from "@swiggy-private/core-ui";
import { isGiftingCartSource } from "@cart-client/helpers/GiftingCart";
import { CartFlowContext } from "@cart-client/contexts/CartFlowContext";

export const usePrefetchTickScreenLottie = () => {
    const { data } = useContext(CartFlowContext);

    const transitionLottieFetchRef = useRef<boolean>(false);

    const isFestivePeriod = isDateWithinInterval(new Date(), FESTIVE_START_DATE, FESTIVE_END_DATE);
    const isGiftingCart = isGiftingCartSource(data?.cartSource);

    useEffect(() => {
        if (isFestivePeriod && !transitionLottieFetchRef.current) {
            fetch(getCloudinaryRawUrl(FESTIVE_LOTTIE_ASSETS.FESTIVE_TRANSITION_LOTTIE_FILE_ID) || "")
                .then(() => {
                    transitionLottieFetchRef.current = true;
                })
                .catch();
        }
        if (isGiftingCart) {
            fetch(getCloudinaryRawUrl(LOTTIE_ASSETS.TRANSITION_LOTTIE_FILE_ID_GIFTING_ORDER_PLACED) || "")
                .then(() => {
                    transitionLottieFetchRef.current = true;
                })
                .catch();
        }
    }, [isFestivePeriod, isGiftingCart]);
};
